jQuery(document).ready(function($) {
    $('#load-all-posts').click(function() {
        let sliderComponentWrapper = $(this).closest('.collection-list-wrapper');
        let sliderComponent = $(this).closest('slider-component');
        let slider = sliderComponent.children('.product-grid');
        let jsonElems = sliderComponent.find('.post-slider-json');
        let extElem = sliderComponent.find('.collection-list__item').last();
        jsonElems.each(function() {
            let index = $(this).data('index');
            let id = $(this).data('id');
            let title = $(this).data('title');
            let image = $(this).data('image');
            let url = $(this).data('url');
            let clone = extElem.clone();
            clone.attr('id', id).css('--animation-order', index);
            clone.find('.card__media img').attr('src', image).removeAttr('loading').removeAttr('srcset');
            clone.find('.title-content').html(title);
            clone.find('.full-unstyled-link').attr('href', url);
            slider.append(clone);
            $(this).remove();
        });
        let cloneSlider = sliderComponent.clone();
        sliderComponent.remove();
        cloneSlider.addClass('all-articles').find('.product-grid').removeClass('post-slider-limit');
        sliderComponentWrapper.append(cloneSlider);
    });
});
